<template>
  <div class="main-wrapper">
    <p>
      Под бенефициарами индивидуального предпринимателя следует понимать
      физическое лицо, которое в конечном счете прямо или косвенно (через
      третьих лиц) имеет возможность контролировать действия индивидуального
      предпринимателя (спонсор, кредитор, инвестор).
    </p>
    <div class="checkboxes">
      <label>
        <input
          type="checkbox"
          class="necessary-bold"
          v-model="ipOnly[0]"
          @click="
            ipOnly = [ipOnly[0], false];
            members = [];
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('BENEF_SELF_IP') != -1
          "
        />
        Бенефициарным владельцем индивидуального предпринимателя является само
        физическое лицо
      </label>
      <label>
        <input
          type="checkbox"
          class="necessary-bold"
          v-model="ipOnly[1]"
          @click="
            ipOnly = [false, ipOnly[1]];
            members = [];
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('BENEF_SELF_IP') != -1
          "
        />
        Бенефициарным владельцем индивидуального предпринимателя является ИНОЕ
        физическое лицо
      </label>
    </div>
    <div v-if="ipOnly[1]">
      <p class="necessary-table-not" v-if="file.FILE == null">
        Приложите документ.
      </p>
      <p class="min-one-file">
        Вы можете приложить только один файл или архив. Если необходимо
        приложить несколько документов, добавьте документы в архив и прикрепите
        архив.
      </p>
      <table class="no-benefs-table">
        <tr class="no-benefs-table-tr">
          <td>
            <input
              type="checkbox"
              v-model="file.checkbox"
              @click="onClickCheckBox()"
              :disabled="!file.checkbox"
            />
          </td>
          <td>
            <p>
              {{ file.CAPTION }}
            </p>
          </td>
          <td width="250px" class="last-column">
            <input
              v-show="file.FILE == null"
              type="file"
              id="file"
              ref="file"
              accept="image/*, .pdf, .zip, .7z, .xls, .xlsx"
              v-on:change="uploadFile()"
              @click="file.FILE = null"
            />
            <div
              class="file-name-icon"
              v-if="file.FILE != null"
              @click="onClickBan()"
            >
              <div class="file-icons">
                <i class="fa fa-trash"></i>
              </div>
              <p class="file-name">{{ file.FILE.name }}</p>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="new-beneficiary" v-if="ipOnly[1]">
      <div>
        <input
          class="new-beneficiary-input"
          type="text"
          v-model="newFIO[0]"
          placeholder="Фамилия"
          :onchanged="
            newFIO[0] != null && newFIO[0].length > 80
              ? (newFIO[0] = newFIO[0].substr(0, 80))
              : newFIO[0]
          "
        />
        <input
          class="new-beneficiary-input"
          type="text"
          v-model="newFIO[1]"
          placeholder="Имя"
          :onchanged="
            newFIO[1] != null && newFIO[1].length > 80
              ? (newFIO[1] = newFIO[1].substr(0, 80))
              : newFIO[1]
          "
        />
        <input
          class="new-beneficiary-input"
          type="text"
          v-model="newFIO[2]"
          placeholder="Отчество (если есть)"
          :onchanged="
            newFIO[2] != null && newFIO[2].length > 80
              ? (newFIO[2] = newFIO[2].substr(0, 80))
              : newFIO[2]
          "
        />
      </div>
      <button class="add-button" @click="createBeneficiary">
        Добавить нового бенефициара
      </button>
    </div>
    <div v-if="ipOnly[1]">
      <div class="item" v-for="member in members" :key="member.id">
        <div class="item-header" @click="changeShow(member)">
          <p>
            <span :class="member.valid ? 'valid-field' : 'unvalid-field'"
              >➤</span
            >
            {{
              member.LAST_NAME + " " + member.FIRST_NAME + " " + member.SUR_NAME
            }}
          </p>
          <div class="icons">
            <i class="fa fa-angle-up" v-if="member.show"></i>
            <i class="fa fa-angle-down" v-if="!member.show"></i>
          </div>
        </div>
        <div class="item-info" v-if="member.show">
          <table>
            <tr>
              <td>
                <p>ИНН (при наличии)</p>
              </td>
              <td>
                <input
                  class="input-line"
                  type="text"
                  v-model="member.INN"
                  v-mask="'############'"
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('INN') != -1
                  "
                />
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">Налоговый статус</p>
              </td>
              <td>
                <dropdown
                  :options="taxesStatuses"
                  :selected="{ name: member.TAX_STATUS }"
                  placeholder="Выберите статус"
                  v-on:updateOption="onSelectTaxesStatus($event, member)"
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('TAX_STATUS') != -1
                  "
                ></dropdown>
              </td>
            </tr>
            <tr>
              <td class="left-column">
                <p>СНИЛС</p>
              </td>
              <td class="right-column">
                <input
                  class="input-line"
                  type="text"
                  v-mask="'###-###-### ##'"
                  v-model="member.SNILS"
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('SNILS') != -1
                  "
                />
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">
                  Тип документа, удостоверяющего личность
                </p>
              </td>
              <td>
                <dropdown
                  :options="docTypes"
                  :selected="{ name: member.DUL_DOCTYPE }"
                  v-on:updateOption="member.DUL_DOCTYPE = $event.name"
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('DUL_DOCTYPE') != -1
                  "
                ></dropdown>
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      member.DUL_SERIAL != null && member.DUL_SERIAL.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Серия документа
                </p>
              </td>
              <td>
                <input
                  class="input-line"
                  type="text"
                  v-model="member.DUL_SERIAL"
                  :onchanged="
                    member.DUL_SERIAL != null &&
                    member.DUL_SERIAL != formatDocNumber(member.DUL_SERIAL)
                      ? (member.DUL_SERIAL = formatDocNumber(member.DUL_SERIAL))
                      : member.DUL_SERIAL
                  "
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('DUL_SERIAL') != -1
                  "
                />
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      member.DUL_NUMBER != null && member.DUL_NUMBER.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Номер документа
                </p>
              </td>
              <td>
                <input
                  class="input-line"
                  type="text"
                  v-model="member.DUL_NUMBER"
                  :onchanged="
                    member.DUL_NUMBER != null &&
                    member.DUL_NUMBER != formatDocNumber(member.DUL_NUMBER)
                      ? (member.DUL_NUMBER = formatDocNumber(member.DUL_NUMBER))
                      : member.DUL_NUMBER
                  "
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('DUL_NUMBER') != -1
                  "
                />
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      !member.unvalidDulDate &&
                      member.DUL_DATE != null &&
                      member.DUL_DATE.length == 10
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Дата выдачи документа
                </p>
              </td>
              <td>
                <input
                  type="text"
                  v-bind:class="
                    member.unvalidDulDate
                      ? 'necessary-unvalid'
                      : 'necessary-valid'
                  "
                  v-mask="'##.##.####'"
                  v-model="member.DUL_DATE"
                  placeholder="дд.мм.гггг"
                  :onchanged="dulDateChanged(member)"
                  @blur="checkDulDate(member)"
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('DUL_DATE') != -1
                  "
                />
                <p class="necessary-message" v-if="member.unvalidDulDate">
                  Введите корректную дату выдачи документа
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      (member.DUL_CODE != null && member.DUL_CODE.length > 0) ||
                      member.hasCode
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Код подразделения
                </p>
                <label>
                  <input
                    type="checkbox"
                    v-model="member.hasCode"
                    id="checkboxEnglishName"
                    @click="
                      member.DUL_CODE = '';
                      isUpdate = true;
                      member.issuerList = [];
                      member.disableIssue = false;
                    "
                    :disabled="
                      member.DISABLED != null &&
                        member.DISABLED.indexOf('DUL_CODE') != -1
                    "
                  />
                  Код подразделения отсутствует
                </label>
              </td>
              <td>
                <input
                  class="input-line"
                  type="text"
                  v-model="member.DUL_CODE"
                  :disabled="
                    member.hasCode ||
                      (member.DISABLED != null &&
                        member.DISABLED.indexOf('DUL_CODE') != -1)
                  "
                  v-mask="'###-###'"
                  :onchanged="
                    member.DUL_CODE != null && member.DUL_CODE.length > 7
                      ? (member.DUL_CODE = member.DUL_CODE.substr(0, 7))
                      : member.DUL_CODE
                  "
                  @input="
                    isUpdate = true;
                    member.DUL_CODE.length == 7 &&
                    member.disableIssue != null &&
                    !member.disableIssue
                      ? getDulIssue(member)
                      : (member.disableIssue = false);
                    member.issuerList = [];
                  "
                />
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      member.DUL_ISSUER != null &&
                      member.DUL_ISSUER.length > 0 &&
                      member.DUL_ISSUER != 'Подразделение не найдено'
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Наименование органа, выдавшего документ
                </p>
              </td>
              <td>
                <dropdown
                  v-if="
                    member.issuerList != null && member.issuerList.length > 1
                  "
                  :options="member.issuerList"
                  :selected="{ name: 'Выберите наименование' }"
                  v-on:updateOption="
                    member.DUL_ISSUER = $event.name;
                    isUpdate = true;
                    $forceUpdate();
                  "
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('DUL_ISSUER') != -1
                  "
                ></dropdown>
                <input
                  v-if="
                    member.issuerList == null || member.issuerList.length <= 1
                  "
                  class="input-line"
                  type="text"
                  v-model="member.DUL_ISSUER"
                  :onchanged="
                    member.DUL_ISSUER != null && member.DUL_ISSUER.length > 80
                      ? (member.DUL_ISSUER = member.DUL_ISSUER.substr(0, 80))
                      : member.DUL_ISSUER
                  "
                  :disabled="
                    (member.disableIssue != null &&
                      member.disableIssue &&
                      !member.hasCode) ||
                      (member.DISABLED != null &&
                        member.DISABLED.indexOf('DUL_ISSUER') != -1)
                  "
                  @focus="
                    member.DUL_ISSUER == 'Подразделение не найдено'
                      ? (member.DUL_ISSUER = '')
                      : member.DUL_ISSUER
                  "
                />
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      !member.unvalidBirthDate &&
                      member.BIRTH_DATE != null &&
                      member.BIRTH_DATE.length == 10
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Дата рождения
                </p>
              </td>
              <td>
                <input
                  type="text"
                  v-bind:class="
                    member.unvalidBirthDate
                      ? 'necessary-unvalid'
                      : 'necessary-valid'
                  "
                  v-mask="'##.##.####'"
                  v-model="member.BIRTH_DATE"
                  placeholder="дд.мм.гггг"
                  :onchanged="birthDateChanged(member)"
                  @blur="checkBirthDate(member)"
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('BIRTH_DATE') != -1
                  "
                />
                <p class="necessary-message" v-if="member.unvalidBirthDate">
                  Введите корректную дату рождения
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      member.BIRTH_PLACE != null &&
                      member.BIRTH_PLACE.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Место рождения
                </p>
              </td>
              <td>
                <input
                  class="input-line"
                  type="text"
                  v-model="member.BIRTH_PLACE"
                  :onchanged="
                    member.BIRTH_PLACE != null && member.BIRTH_PLACE.length > 80
                      ? (member.BIRTH_PLACE = member.BIRTH_PLACE.substr(0, 80))
                      : member.BIRTH_PLACE
                  "
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('BIRTH_PLACE') != -1
                  "
                />
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      member.CITIZENSHIP != null &&
                      member.CITIZENSHIP.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Гражданство (подданство) (указываются все страны, в которых
                  физическое лицо имеет гражданство)
                </p>
              </td>
              <td>
                <input
                  class="input-line"
                  type="text"
                  v-model="member.CITIZENSHIP"
                  :onchanged="
                    member.CITIZENSHIP != null && member.CITIZENSHIP.length > 80
                      ? (member.CITIZENSHIP = member.CITIZENSHIP.substr(0, 80))
                      : member.CITIZENSHIP
                  "
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('CITIZENSHIP') != -1
                  "
                />
              </td>
            </tr>
            <tr v-if="member.TAX_STATUS == 'Нерезидент'">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      member.HAS_MIGRATION_CARD != null
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Наличие миграционной карты
                </p>
              </td>
              <td>
                <dropdown
                  :options="hasCards"
                  :selected="{ name: member.HAS_MIGRATION_CARD }"
                  placeholder="Наличие карты"
                  v-on:updateOption="migrationCardChoose(member, $event.name)"
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('HAS_MIGRATION_CARD') != -1
                  "
                ></dropdown>
              </td>
            </tr>
            <tr v-if="member.HAS_MIGRATION_CARD == 'Есть'">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      member.MIGRATION_CARD_NO != null &&
                      member.MIGRATION_CARD_NO.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Номер миграционной карты
                </p>
              </td>
              <td>
                <input
                  class="input-line"
                  type="text"
                  v-model="member.MIGRATION_CARD_NO"
                  :onchanged="
                    member.MIGRATION_CARD_NO != null &&
                    member.MIGRATION_CARD_NO.length > 63
                      ? (member.MIGRATION_CARD_NO = member.MIGRATION_CARD_NO.substr(
                          0,
                          63
                        ))
                      : member.MIGRATION_CARD_NO
                  "
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('MIGRATION_CARD_NO') != -1
                  "
                />
              </td>
            </tr>
            <tr v-if="member.HAS_MIGRATION_CARD == 'Есть'">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      member.DATE_FROM != null &&
                      member.DATE_FROM.length == 10 &&
                      !member.unvalidDateFrom
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Дата начала срока пребывания в Российской Федерации
                </p>
              </td>
              <td>
                <input
                  type="text"
                  v-bind:class="
                    member.unvalidDateFrom
                      ? 'necessary-unvalid'
                      : 'necessary-valid'
                  "
                  v-mask="'##.##.####'"
                  v-model="member.DATE_FROM"
                  placeholder="дд.мм.гггг"
                  :onchanged="dateFromChanged(member)"
                  @blur="checkDateTo(member)"
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('DATE_FROM') != -1
                  "
                />
                <p class="necessary-message" v-if="member.unvalidDateFrom">
                  Введите корректную начала срока пребывания в Российской
                  Федерации
                </p>
              </td>
            </tr>
            <tr v-if="member.HAS_MIGRATION_CARD == 'Есть'">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      member.DATE_TO != null &&
                      member.DATE_TO.length == 10 &&
                      !member.unvalidDateTo
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Дата окончания срока пребывания в Российской Федерации
                </p>
              </td>
              <td>
                <input
                  type="text"
                  v-bind:class="
                    member.unvalidDateTo
                      ? 'necessary-unvalid'
                      : 'necessary-valid'
                  "
                  v-mask="'##.##.####'"
                  v-model="member.DATE_TO"
                  placeholder="дд.мм.гггг"
                  :onchanged="dateToChanged(member)"
                  @blur="checkDateFrom(member)"
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('DATE_TO') != -1
                  "
                />
                <p class="necessary-message" v-if="member.unvalidDateTo">
                  Введите корректную окончания срока пребывания в Российской
                  Федерации
                </p>
              </td>
            </tr>
            <tr v-if="member.TAX_STATUS == 'Нерезидент'">
              <td>
                <p>
                  Документ, подтверждающий право иностранного гражданина или
                  лица без гражданства на пребывание (проживание) в Российской
                  Федерации
                </p>
                <label>
                  <input
                    type="checkbox"
                    v-model="member.hasDocNo"
                    @click="member.FOREIGNMAN_DOCNO = ''"
                    :disabled="
                      member.DISABLED != null &&
                        member.DISABLED.indexOf('FOREIGNMAN_DOCNO') != -1
                    "
                  />
                  Документ отсутствует
                </label>
              </td>
              <td>
                <input
                  type="text"
                  class="input-line"
                  v-model="member.FOREIGNMAN_DOCNO"
                  :disabled="
                    member.hasDocNo ||
                      (member.DISABLED != null &&
                        member.DISABLED.indexOf('FOREIGNMAN_DOCNO') != -1)
                  "
                  :onchanged="
                    member.FOREIGNMAN_DOCNO != null &&
                    member.FOREIGNMAN_DOCNO.length > 255
                      ? (member.FOREIGNMAN_DOCNO = member.FOREIGNMAN_DOCNO.substr(
                          0,
                          255
                        ))
                      : member.FOREIGNMAN_DOCNO
                  "
                />
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      member.REG_ADDRESS != null &&
                      member.REG_ADDRESS.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Адрес места жительства (регистрации)
                </p>
              </td>
              <td>
                <input
                  class="input-line"
                  type="text"
                  v-model="member.REG_ADDRESS"
                  :onchanged="
                    member.REG_ADDRESS != null &&
                    member.REG_ADDRESS.length > 1000
                      ? (member.REG_ADDRESS = member.REG_ADDRESS.substr(
                          0,
                          1000
                        ))
                      : member.REG_ADDRESS
                  "
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('REG_ADDRESS') != -1
                  "
                />
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      member.FACT_ADDRESS != null &&
                      member.FACT_ADDRESS.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Адрес места пребывания
                </p>
                <label>
                  <input
                    type="checkbox"
                    v-model="member.live_like_registration"
                    :checked="
                      member.live_like_registration
                        ? (member.FACT_ADDRESS = member.REG_ADDRESS)
                        : member.FACT_ADDRESS
                    "
                    :disabled="
                      member.DISABLED != null &&
                        member.DISABLED.indexOf('FACT_ADDRESS') != -1
                    "
                  />Совпадает с местом жительства
                </label>
              </td>
              <td>
                <input
                  type="text"
                  class="input-line"
                  v-model="member.FACT_ADDRESS"
                  :disabled="
                    member.live_like_registration ||
                      (member.DISABLED != null &&
                        member.DISABLED.indexOf('FACT_ADDRESS') != -1)
                  "
                  :onchanged="
                    member.FACT_ADDRESS != null &&
                    member.FACT_ADDRESS.length > 1000
                      ? (member.FACT_ADDRESS = member.FACT_ADDRESS.substr(
                          0,
                          1000
                        ))
                      : member.FACT_ADDRESS
                  "
                />
              </td>
            </tr>
            <tr>
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      member.POST_ADDRESS != null &&
                      member.POST_ADDRESS.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Почтовый адрес
                </p>
                <div class="checkboxes">
                  <label>
                    <input
                      type="checkbox"
                      v-model="member.mail_like_addresses[0]"
                      :checked="
                        !member.mail_like_addresses[1] &&
                        member.mail_like_addresses[0]
                          ? (member.POST_ADDRESS = member.REG_ADDRESS)
                          : member.POST_ADDRESS
                      "
                      @click="
                        member.mail_like_addresses = [
                          member.mail_like_addresses[0],
                          false,
                        ]
                      "
                      :disabled="
                        member.DISABLED != null &&
                          member.DISABLED.indexOf('POST_ADDRESS') != -1
                      "
                    />Совпадает с местом жительства
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      v-model="member.mail_like_addresses[1]"
                      :checked="
                        member.mail_like_addresses[1] &&
                        !member.mail_like_addresses[0]
                          ? (member.POST_ADDRESS = member.FACT_ADDRESS)
                          : member.POST_ADDRESS
                      "
                      @click="
                        member.mail_like_addresses = [
                          false,
                          member.mail_like_addresses[1],
                        ]
                      "
                      :disabled="
                        member.DISABLED != null &&
                          member.DISABLED.indexOf('POST_ADDRESS') != -1
                      "
                    />Совпадает с местом пребывания
                  </label>
                </div>
              </td>
              <td>
                <input
                  type="text"
                  class="input-line"
                  v-model="member.POST_ADDRESS"
                  :disabled="
                    member.mail_like_addresses[0] ||
                      member.mail_like_addresses[1] ||
                      (member.DISABLED != null &&
                        member.DISABLED.indexOf('POST_ADDRESS') != -1)
                  "
                  :onchanged="
                    member.POST_ADDRESS != null &&
                    member.POST_ADDRESS.length > 1000
                      ? (member.POST_ADDRESS = member.POST_ADDRESS.substr(
                          0,
                          1000
                        ))
                      : member.POST_ADDRESS
                  "
                />
              </td>
            </tr>
            <tr>
              <td>
                <p>Телефон</p>
              </td>
              <td>
                <input
                  type="text"
                  class="input-line"
                  v-mask="'+7 (###) ###-##-##'"
                  v-model="member.PHONE_NUMBER"
                  placeholder="+7 (###) ###-##-##"
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('PHONE_NUMBER') != -1
                  "
                />
              </td>
            </tr>
            <tr>
              <td>
                <p>Адрес электронной почты</p>
              </td>
              <td>
                <input
                  type="text"
                  v-bind:class="
                    member.unvalidEmail
                      ? 'necessary-unvalid'
                      : 'necessary-valid'
                  "
                  v-model="member.E_MAIL"
                  placeholder="example@mail.com"
                  :onchanged="
                    member.E_MAIL != null && member.E_MAIL.length > 100
                      ? (member.E_MAIL = member.E_MAIL.substr(0, 100))
                      : member.E_MAIL
                  "
                  @blur="checkEmail(member)"
                  :disabled="
                    member.DISABLED != null &&
                      member.DISABLED.indexOf('E_MAIL') != -1
                  "
                />
                <p class="necessary-message" v-if="member.unvalidEmail">
                  Введите корректный адрес электронной почты
                </p>
              </td>
            </tr>
          </table>

          <p
            class="necessary-table-not"
            v-if="!(member.dataIsRight[0] || member.dataIsRight[1])"
          >
            Подтвердите корректность данных, заполненных автоматически.
          </p>
          <div class="data-is-right-checkboxes">
            <label>
              <input
                type="checkbox"
                v-model="member.dataIsRight[0]"
                @click="member.dataIsRight = [member.dataIsRight[0], false]"
                :disabled="
                  member.DISABLED != null &&
                    member.DISABLED.indexOf('IS_DATA_VALID') != -1
                "
              />Данные верны
            </label>
            <label>
              <input
                type="checkbox"
                v-model="member.dataIsRight[1]"
                @click="
                  member.dataIsRight = [false, member.dataIsRight[1]];
                  member.BENEFICIARY_LIST_INVALID_DATA = '';
                "
                :disabled="
                  member.DISABLED != null &&
                    member.DISABLED.indexOf('IS_DATA_VALID') != -1
                "
              />Внести изменения
            </label>
          </div>
          <div v-show="member.dataIsRight[1]" class="invalid-data">
            <p class="necessary-bold">
              <span
                :class="
                  (member.BENEFICIARY_LIST_INVALID_DATA != null &&
                    member.BENEFICIARY_LIST_INVALID_DATA.length > 0) ||
                  !member.dataIsRight[1]
                    ? 'valid-field'
                    : 'unvalid-field'
                "
                >➤</span
              >
              Укажите строку, в которой указаны неверные данные и укажите верные
              данные
            </p>
            <textarea
              class="invalid-data-textarea"
              v-model="member.BENEFICIARY_LIST_INVALID_DATA"
              :disabled="
                member.DISABLED != null &&
                  member.DISABLED.indexOf('BENEFICIARY_LIST_INVALID_DATA') != -1
              "
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dropdown from "vue-dropdowns";
import mask from "./utils/my-mask.js";
import dateConventer from "./utils/date-converter.js";
import fieldFormatter from "./utils/field-formatter.js";
export default {
  name: "BeneficiaryList",
  components: {
    dropdown,
  },
  props: {
    pageInfo: {},
    pageName: String,
    url: String,
  },
  data: () => ({
    newFIO: ["", "", ""],
    file: {
      CAPTION:
        "Документ, удостоверяющий личность каждого бенефициарного владельца (и если бенефициар иностранное лицо, то миграционная карта и документ подтверждающий пребывание на территории РФ).",
      FILE: null,
      checkbox: false,
    },
    hasCards: [{ name: "Есть" }, { name: "Нет" }],
    ipOnly: [false, false],
    bases: [
      { name: "Прямо владеет более 25% в капитале" },
      { name: "Косвенно владеет более 25% в капитале" },
      { name: "Должность (ЕИО)" },
      { name: "Влияет на принятие решений" },
      { name: "Является собственником бизнеса" },
    ],
    docTypes: [
      { name: "Паспорт гражданина РФ" },
      { name: "Загранпаспорт гражданина РФ" },
      { name: "Удостоверение личности военнослужащего РФ" },
      { name: "Паспорт иностранного гражданина" },
      { name: "Удостоверение беженца" },
      {
        name:
          "Свидетельство о предоставлении временного убежища на территории РФ",
      },
    ],
    taxesStatuses: [
      {
        name: "Резидент",
      },
      {
        name: "Нерезидент",
      },
    ],
    members: [],
    clickShow: false,
    sendData: {},
  }),
  methods: {
    formatDocNumber(field) {
      return fieldFormatter.formatDocNumber(field);
    },
    changeShow(member) {
      member.show = !member.show;
      this.clickShow = true;
    },
    checkDate(date) {
      return mask.date(date);
    },
    onSelectTaxesStatus(event, member) {
      delete member.HAS_MIGRATION_CARD;
      member.TAX_STATUS = event.name;
      this.$forceUpdate();
    },
    birthDateChanged(member) {
      if (member.BIRTH_DATE != this.checkDate(member.BIRTH_DATE))
        member.BIRTH_DATE = this.checkDate(member.BIRTH_DATE);
      if (member.BIRTH_DATE != null && member.BIRTH_DATE.length == 10)
        this.checkBirthDate(member);
      else member.unvalidBirthDate = false;
    },
    dulDateChanged(member) {
      if (member.DUL_DATE != this.checkDate(member.DUL_DATE))
        member.DUL_DATE = this.checkDate(member.DUL_DATE);
      if (member.DUL_DATE != null && member.DUL_DATE.length == 10)
        this.checkDulDate(member);
      else member.unvalidDulDate = false;
    },
    dateFromChanged(member) {
      if (member.DATE_FROM != this.checkDate(member.DATE_FROM))
        member.DATE_FROM = this.checkDate(member.DATE_FROM);
      if (member.DATE_FROM != null && member.DATE_FROM.length == 10)
        this.checkDateFrom(member);
      else member.unvalidDateFrom = false;
    },
    dateToChanged(member) {
      if (member.DATE_TO != this.checkDate(member.DATE_TO))
        member.DATE_TO = this.checkDate(member.DATE_TO);
      if (member.DATE_TO != null && member.DATE_TO.length == 10)
        this.checkDateTo(member);
      else member.unvalidDateTo = false;
    },
    createBeneficiary() {
      if (this.newFIO[0].length * this.newFIO[1].length != 0) {
        this.hasBenefs = false;
        this.members.push({
          id: this.members.length,
          LAST_NAME: this.newFIO[0],
          FIRST_NAME: this.newFIO[1],
          SUR_NAME: this.newFIO[2],
          DUL_DOCTYPE: "Паспорт гражданина РФ",
          DUL_NUMBER: "",
          DUL_SERIAL: "",
          INN: "",
          DUL_DATE: "",
          DUL_ISSUER: "",
          BIRTH_DATE: "",
          BIRTH_PLACE: "",
          CITIZENSHIP: "",
          SNILS: "",
          TAX_STATUS: "Резидент",
          REG_ADDRESS: "",
          FACT_ADDRESS: "",
          POST_ADDRESS: "",
          PHONE_NUMBER: "",
          DATE_FROM: "",
          DATE_TO: "",
          MIGRATION_CARD_NO: "",
          FOREIGNMAN_DOCNO: "",
          E_MAIL: "",
          hasCode: false,
          dataIsRight: [false, false],
          show: true,
          disable: false,
          live_like_registration: false,
          mail_like_addresses: [false, false],
          unvalidEmail: false,
          unvalidBirthDate: false,
          unvalidDulDate: false,
          hasDocno: false,
          valid: false,
          BENEFICIARY_LIST_INVALID_DATA: "",
        });
        this.newFIO = ["", "", ""];
      }
    },
    fillBeneficiary(data) {
      if (data.TAX_STATUS == null || data.TAX_STATUS)
        data.TAX_STATUS = "Резидент";
      else data.TAX_STATUS = "Нерезидент";
      data.show = false;
      data.live_like_registration = false;
      data.mail_like_addresses = [false, false];
      data.issuerList = [];
      if (data.IS_DATA_VALID != null)
        data.dataIsRight = [data.IS_DATA_VALID, !data.IS_DATA_VALID];
      else data.dataIsRight = [false, false];
      data.unvalidEmail = false;
      data.unvalidBirthDate = false;
      data.unvalidDulDate = false;
      data.unvalidDateFrom = false;
      (data.hasDocNo = false), (data.unvalidDateTo = false);
      data.disable = false;
      data.valid = false;
      if (data.DUL_DOCTYPE == null) data.DUL_DOCTYPE = "Паспорт гражданина РФ";
      if (data.DUL_CODE == null) data.DUL_CODE = "";
      data.hasCode =
        (data.DUL_CODE == null || data.DUL_CODE.length == 0) &&
        data.CITIZENSHIP != null;
      if (data.DUL_DATE == null) data.DUL_DATE = "";
      else data.DUL_DATE = dateConventer.fromServerConvert(data.DUL_DATE);
      if (data.BIRTH_DATE == null) data.BIRTH_DATE = "";
      else data.BIRTH_DATE = dateConventer.fromServerConvert(data.BIRTH_DATE);
      if (data.PHONE_NUMBER == null) data.PHONE_NUMBER = "";
      if (data.DUL_NUMBER == null) data.DUL_NUMBER = "";
      if (data.DUL_SERIAL == null) data.DUL_SERIAL = "";
      if (data.DUL_ISSUER == null) data.DUL_ISSUER = "";
      if (data.BIRTH_PLACE == null) data.BIRTH_PLACE = "";
      if (data.CITIZENSHIP == null) data.CITIZENSHIP = "";
      if (data.LAST_NAME == null) data.LAST_NAME = "";
      if (data.SUR_NAME == null) data.SUR_NAME = "";
      if (data.FIRST_NAME == null) data.FIRST_NAME = "";
      if (data.REG_ADDRESS == null) data.REG_ADDRESS = "";
      if (data.FACT_ADDRESS == null) data.FACT_ADDRESS = "";
      if (data.POST_ADDRESS == null) data.POST_ADDRESS = "";
      if (data.E_MAIL == null) data.E_MAIL = "";
      if (data.INN == null) data.INN = "";
      if (data.SNILS == null) data.SNILS = "";
      if (data.DUL_CODE == null) data.DUL_CODE = "";
      if (data.MIGRATION_CARD_NO == null) data.MIGRATION_CARD_NO = "";
      else data.HAS_MIGRATION_CARD = "Есть";
      if (data.HAS_MIGRATION_CARD != null)
        data.HAS_MIGRATION_CARD
          ? (data.HAS_MIGRATION_CARD = "Есть")
          : (data.HAS_MIGRATION_CARD = "Нет");
      if (data.DATE_FROM == null) data.DATE_FROM = "";
      else data.DATE_FROM = dateConventer.fromServerConvert(data.DATE_FROM);
      if (data.DATE_TO == null) data.DATE_TO = "";
      else data.DATE_TO = dateConventer.fromServerConvert(data.DATE_TO);
      if (data.FOREIGNMAN_DOCNO == null) data.FOREIGNMAN_DOCNO = "";
      if (data.BENEFICIARY_LIST_INVALID_DATA == null)
        data.BENEFICIARY_LIST_INVALID_DATA = "";
    },
    checkDulDate(info) {
      let date = new Date();
      let dulDate = info.DUL_DATE;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let dul_year = parseInt(dulDate.split(".")[2]);
      let dul_months = parseInt(dulDate.split(".")[1]);
      let dul_days = parseInt(dulDate.split(".")[0]);
      if (dulDate.length == 10) {
        info.unvalidDulDate = !(
          dul_year < year ||
          (dul_year == year && dul_months < month) ||
          (dul_year == year && dul_months == month && dul_days < day)
        );
        if (info.unvalidDulDate)
          info.dulDateErrorMessage = "Введите корректную дату выдачи документа";
      } else if (dulDate.length == 0) {
        info.unvalidDulDate = false;
      } else {
        info.unvalidDulDate = true;
      }
    },
    checkDateTo(info) {
      let date = new Date();
      let dulDate = info.DATE_TO;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let dul_year = parseInt(dulDate.split(".")[2]);
      let dul_months = parseInt(dulDate.split(".")[1]);
      let dul_days = parseInt(dulDate.split(".")[0]);
      if (dulDate.length == 10) {
        info.unvalidDateTo = !(
          dul_year > year ||
          (dul_year == year && dul_months > month) ||
          (dul_year == year && dul_months == month && dul_days > day)
        );
      } else if (dulDate.length == 0) {
        info.unvalidDateTo = false;
      } else {
        info.unvalidDateTo = true;
      }
    },
    checkBirthDate(info) {
      let date = new Date();
      let birthDate = info.BIRTH_DATE;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let dul_year = parseInt(birthDate.split(".")[2]);
      let dul_months = parseInt(birthDate.split(".")[1]);
      let dul_days = parseInt(birthDate.split(".")[0]);
      if (birthDate.length == 10) {
        info.unvalidBirthDate = !(
          dul_year < year ||
          (dul_year == year && dul_months < month) ||
          (dul_year == year && dul_months == month && dul_days < day)
        );
        if (info.unvalidBirthDate)
          info.birthDateErrorMessage =
            "Введите корректную дату выдачи документа";
      } else if (birthDate.length == 0) {
        info.unvalidBirthDate = false;
      } else {
        info.unvalidBirthDate = true;
      }
    },
    uploadFile() {
      this.file.FILE = this.$refs.file.files[0];
      this.file.checkbox = this.file.FILE != null;
      this.validation();
      this.$emit("updated");
    },
    onClickBan() {
      this.file.FILE = null;
      this.file.checkbox = false;
      this.validation();
      this.$emit("updated");
    },
    checkDateFrom(info) {
      let date = new Date();
      let birthDate = info.DATE_FROM;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let dul_year = parseInt(birthDate.split(".")[2]);
      let dul_months = parseInt(birthDate.split(".")[1]);
      let dul_days = parseInt(birthDate.split(".")[0]);
      if (birthDate.length == 10) {
        info.unvalidDateFrom = !(
          dul_year < year ||
          (dul_year == year && dul_months < month) ||
          (dul_year == year && dul_months == month && dul_days < day)
        );
      } else if (birthDate.length == 0) {
        info.unvalidDateFrom = false;
      } else {
        info.unvalidDateFrom = true;
      }
    },
    migrationCardChoose(member, name) {
      member.HAS_MIGRATION_CARD = name;
      if (name == "Нет") {
        member.MIGRATION_CARD_NO = "";
        member.DATE_FROM = "";
        member.DATE_TO = "";
      }
      this.$forceUpdate();
    },
    checkInformation(item) {
      var msg = "Для ";
      if (item.FIRST_NAME != null && item.FIRST_NAME.length > 0)
        msg += item.FIRST_NAME.substr(0, 1) + ". ";
      if (item.SUR_NAME != null && item.SUR_NAME.length > 0)
        msg += item.SUR_NAME.substr(0, 1) + ". ";
      msg += item.LAST_NAME + " заполните поля:<br>";
      if (
        item.DUL_DATE == null ||
        item.DUL_DATE.length != 10 ||
        item.unvalidDulDate
      )
        msg += "• Дата выдачи документа<br>";
      if (
        item.BIRTH_DATE == null ||
        item.BIRTH_DATE.length != 10 ||
        item.unvalidBirthDate
      )
        msg += "• Дата рождения<br>";
      if (item.HAS_MIGRATION_CARD == null && item.TAX_STATUS == "Нерезидент") {
        msg += "• Наличие миграционной карты<br>";
      }
      if (item.HAS_MIGRATION_CARD == "Есть") {
        if (
          item.DATE_FROM == null ||
          item.DATE_FROM.length != 10 ||
          item.unvalidDateFrom
        )
          msg += "• Дата начала срока пребывания в Российской Федерации<br>";
        if (
          item.DATE_TO == null ||
          item.DATE_TO.length != 10 ||
          item.unvalidDateTo
        )
          msg += "• Дата окончания срока пребывания в Российской Федерации<br>";
        if (
          item.MIGRATION_CARD_NO == null ||
          item.MIGRATION_CARD_NO.length == 0
        )
          msg += "• Номер миграционной карты<br>";
      }
      if (item.DUL_NUMBER == null || item.DUL_NUMBER.length == 0)
        msg += "• Номер документа<br>";
      if (item.DUL_SERIAL == null || item.DUL_SERIAL.length == 0)
        msg += "• Серия документа<br>";
      if ((item.DUL_CODE == null || item.DUL_CODE.length == 0) && !item.hasCode)
        msg += "• Код подразделения<br>";
      if (
        item.DUL_ISSUER == null ||
        item.DUL_ISSUER.length == 0 ||
        item.DUL_ISSUER == "Подразделение не найдено"
      )
        msg += "• Наименование органа, выдавшего документ<br>";
      if (item.BIRTH_PLACE == null || item.BIRTH_PLACE.length == 0)
        msg += "• Место рождения<br>";
      if (item.CITIZENSHIP == null || item.CITIZENSHIP.length == 0)
        msg += "• Гражданство<br>";
      if (item.REG_ADDRESS == null || item.REG_ADDRESS.length == 0)
        msg += "• Адрес места жительства<br>";
      if (item.FACT_ADDRESS == null || item.FACT_ADDRESS.length == 0)
        msg += "• Адрес места пребывания<br>";
      if (item.POST_ADDRESS == null || item.POST_ADDRESS.length == 0)
        msg += "• Почтовый адрес<br>";
      if (!(item.dataIsRight[0] || item.dataIsRight[1]))
        msg +=
          "• Подтвердите корректность данных, заполненных автоматически<br>";
      if (msg.indexOf("•") != -1) return msg;
      else return "";
    },
    checkEmail(data) {
      data.unvalidEmail = mask.emailCheck(data.E_MAIL);
    },
    async getDulIssue(info) {
      try {
        info.DUL_ISSUER = "";
        if (!info.disableIssue) {
          info.disableIssue = true;
          let response = await fetch(this.url + "get_passp_issuer_by_code", {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify({
              DUL_CODE: info.DUL_CODE,
            }),
          });
          if (response.ok) {
            let data = await response.json();
            if (data.DUL_ISSUER != null) {
              switch (data.DUL_ISSUER.length) {
                case 0:
                  info.DUL_ISSUER = "Подразделение не найдено";
                  info.disableIssue = false;
                  break;
                case 1:
                  info.DUL_ISSUER = data.DUL_ISSUER[0];
                  info.disableIssue = true;
                  break;
                default:
                  info.issuerList = [];
                  info.disableIssue = true;
                  for (let i = 0; i < data.DUL_ISSUER.length; i++) {
                    info.issuerList.push({ name: data.DUL_ISSUER[i] });
                  }
                  break;
              }
            } else {
              info.DUL_ISSUER = "Подразделение не найдено";
              info.disableIssue = false;
            }
          } else throw new Error("Ошибка получения наименования подразделения");
        }
      } catch (e) {
        info.disableIssue = false;
        console.log(e);
      }
      this.$forceUpdate();
      this.validation();
    },
    validation() {
      var msg = "";
      // if (this.ipOnly[1] && this.file.FILE == null)
      //   msg += "• Приложите файл<br>";
      if (this.members.length == 0 && this.ipOnly[1])
        msg += "• Добавьте хотя бы одного бенефициара<br>";
      if (this.ipOnly[1])
        this.members.forEach((item) => {
          var tmp_msg = this.checkInformation(item);
          item.valid = tmp_msg.length == 0;
          msg += tmp_msg;
        });
      if (!(this.ipOnly[0] || this.ipOnly[1]))
        msg += "• Укажите, кто является бенефициаром";
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        if (this.ipOnly[1]) {
          var m_list = JSON.parse(JSON.stringify(this.members));
          m_list.forEach((item) => {
            item.TAX_STATUS = item.TAX_STATUS == "Резидент";
            item.IS_DATA_VALID = item.dataIsRight[0];
            if (item.IS_DATA_VALID) delete item.BENEFICIARY_LIST_INVALID_DATA;
            if (!item.TAX_STATUS)
              item.HAS_MIGRATION_CARD = item.HAS_MIGRATION_CARD == "Есть";
            else {
              delete item.HAS_MIGRATION_CARD;
              delete item.MIGRATION_CARD_NO;
              delete item.FOREIGNMAN_DOCNO;
              delete item.DATE_FROM;
              delete item.DATE_TO;
            }
          });
          this.sendData.BENEFITIARS = m_list;
        } else delete this.sendData.BENEFITIARS;
        if (
          (this.file.FILE != null &&
            (this.pageInfo.FILES == null || this.pageInfo.FILES.length == 0)) ||
          (this.pageInfo.FILES != null &&
            this.pageInfo.FILES.length > 0 &&
            (this.file.FILE == null ||
              this.pageInfo.FILES[0].DS_FILE_NAME != this.file.FILE.name))
        )
          this.sendData.FILES = [this.file];
        this.sendData.BENEF_SELF_IP = this.ipOnly[0];
        this.$emit(
          "changePageSendData",
          this.sendData,
          this.sendData.FILES != null
        );
      }
    },
  },
  async created() {
    this.sendData.INN = this.pageInfo.INN;

    this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
    this.sendData.ID = this.pageInfo.ID;
    if (this.pageInfo.BENEF_SELF_IP != null) {
      this.ipOnly = [this.pageInfo.BENEF_SELF_IP, !this.pageInfo.BENEF_SELF_IP];
      if (
        this.ipOnly[1] &&
        this.pageInfo.FILES != null &&
        this.pageInfo.FILES.length != 0
      ) {
        this.file.FILE = { name: this.pageInfo.FILES[0].DS_FILE_NAME };
        this.file.checkbox = true;
      }
    }
    if (
      this.pageInfo.BENEFITIARS != null &&
      this.pageInfo.BENEFITIARS.length > 0
    ) {
      this.ipOnly = [false, true];
      for (let i = 0; i < this.pageInfo.BENEFITIARS.length; i++) {
        this.pageInfo.BENEFITIARS[i].id = i;
        this.fillBeneficiary(this.pageInfo.BENEFITIARS[i]);
      }
      this.members = JSON.parse(JSON.stringify(this.pageInfo.BENEFITIARS));
    }
    this.validation();
    this.$emit("buttons", false, true);
  },
  updated() {
    this.validation();
    if (!this.clickShow) this.$emit("updated");
    this.clickShow = false;
  },
};
</script>

<style scoped>
.item {
  border: 1px solid #555555;
  margin-top: 10px;
}
.main-wrapper {
  text-align: justify;
}
.left-column {
  width: 30%;
  display: flex;
  flex-direction: column;
}
.right-column {
  width: 70%;
}
table {
  border-collapse: collapse;
  padding: 0px 5px;
}
.item-header {
  width: 100%;
  margin-top: 10px;
  cursor: default;
  text-align: center;
}
.icons {
  background-color: white;
  border: none;
  color: black;
  position: relative;
  font-size: 15px;
}
.input-line {
  border: none;
  width: 100%;
  border-bottom: 1px solid #cccccc;
  margin-left: 0px;
}
input[type="text"]:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
td {
  padding: 5px 10px;
}
tr {
  border-top: 1px solid black;
}
.add-button {
  justify-content: center;
  background-color: #06569b;
  border: 0px;
  border-radius: 6px;
  padding: 2px 2px;
  margin-left: 20px;
  font-size: 20px;
  outline: none;
  color: white;
  font-size: 15px;
  cursor: pointer;
}
.add-button:hover {
  background-color: #85b0f8;
}
.new-beneficiary {
  display: flex;
  flex-direction: row;
  margin-top: 15px;
}
hr {
  height: 5px;
  background-color: #cccccc;
}
.checkboxes {
  display: flex;
  flex-direction: column;
}
.new-beneficiary-input {
  margin-left: 0px;
  margin-bottom: 5px;
  border: none;
  width: 100%;
  border-bottom: 1px solid #cccccc;
  margin-left: 0px;
}
tr {
  margin-right: 20px;
}
table {
  padding: 0px 5px;
  width: 100%;
  text-align: left;
}
.radio-correct-data {
  padding: 10px 10px;
  display: flex;
  flex-direction: row;
}
.right-radio {
  margin-left: 10px;
}
.necessary {
  color: red;
}
.data-is-right-checkboxes {
  text-align: center;
  padding: 5px 0px;
}
.necessary-message {
  color: red;
  font-size: 12px;
}
.necessary-unvalid {
  border: none;
  border-bottom: 1px solid red;
  width: 100%;
}
.necessary-valid {
  border: none;
  width: 100%;
  border-bottom: 1px solid #cccccc;
}
.no-benefs-checkbox {
  margin: 10px 5px;
}
.file-icons {
  position: absolute;
  padding-left: 255px;
  padding-top: 5px;
  background-color: white;
  border: none;
  color: red;
  font-size: 17px;
}
.no-benefs-table {
  border: 1px solid #cccccc;
}
.no-benefs-table-tr {
  border-top: 0px;
}
</style>
